
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M20 15.31L21.9 13.41C22.68 12.63 22.68 11.36 21.9 10.58L20 8.69001V6.00001C20 4.90001 19.1 4.00001 18 4.00001H15.31L13.41 2.10001C12.63 1.32001 11.36 1.32001 10.58 2.10001L8.69001 4.00001H6.00001C4.90001 4.00001 4.00001 4.90001 4.00001 6.00001V8.69001L2.10001 10.59C1.32001 11.37 1.32001 12.64 2.10001 13.42L4.00001 15.32V18C4.00001 19.1 4.90001 20 6.00001 20H8.69001L10.59 21.9C11.37 22.68 12.64 22.68 13.42 21.9L15.32 20H18C19.1 20 20 19.1 20 18V15.31ZM12 16.9V7.10001C12 6.49001 12.55 5.99002 13.15 6.11001C15.91 6.65001 18 9.08001 18 12C18 14.92 15.91 17.35 13.15 17.89C12.55 18.01 12 17.51 12 16.9Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-brightness-medium`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconBrightnessMedium

    ```js
    <b-new-b-icon-brightness-medium />
    ```
</docs>


